import type {
  DeepPartial,
  Entry as UserEntry,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useSaveEntry,
  useCreateEntry,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import type { DeepReadonlyObject } from "rxdb"

import {
  useCreateCollectionItem,
  useUpdateCollectionItem,
} from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

type PartialUserEntry = DeepReadonlyObject<DeepPartial<UserEntry>>

export function useSaveUserEntry() {
  const createUserEntry = useCreateCollectionItem(
    CollectionKey.UserEntry,
    "entry",
    useCreateEntry,
    (i) => i,
  )

  const updateUserEntry = useUpdateCollectionItem(
    CollectionKey.UserEntry,
    "entry",
    useSaveEntry,
    (i) => i,
  )

  return useCallback(
    (userEntry: PartialUserEntry) => {
      if (userEntry.id) {
        return updateUserEntry({
          ...userEntry,
          id: userEntry.id,
        })
      }

      return createUserEntry(userEntry)
    },
    [
      createUserEntry,
      updateUserEntry,
    ],
  )
}
